import { useState, useEffect, useCallback } from "react";
import { standardRequestsApi } from "../../api/api";

export const useStandard = (atsId, pageNumber = 1, pageSize = 1000) => {
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  const fetchData = useCallback(async () => {
    if (!atsId) return;
    setIsFetching(true);
    try {
      const response = await standardRequestsApi.getStandardByAts(pageNumber, pageSize, atsId);
      setData(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsFetching(false);
    }
  }, [atsId, pageNumber, pageSize]);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, [fetchData]);

  return { data, isFetching, refetch: fetchData };
};
